import { errorAlert } from 'cadenza/alert';
import { hasThemeGroups } from 'cadenza/api-client/theme-group-api';
import { LayerProperty } from 'cadenza/map/layer-property';
import { logger } from 'cadenza/utils/logging';

import { LayerAction } from './layer-action';
import i18n from './layer-actions.properties';

export class ThemeGroupIntersectionAction extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('themeGroupIntersection')
    }, options));
    this.#map = options.map;
  }

  execute () {
    let wizard;
    return import(/* webpackChunkName: "theme-group-intersection-wizard" */ 'cadenza/theme-group-intersection-wizard/theme-group-intersection-wizard')
      .then(({ ThemeGroupIntersectionWizard }) => {
        wizard = new ThemeGroupIntersectionWizard(this.#map, this._layer.get(LayerProperty.ID));
        document.body.appendChild(wizard);
        return wizard.showModal();
      })
      .then(() => wizard.remove())
      .catch(error => {
        logger.error('Failed to start theme group intersection wizard.', error);
        errorAlert(
          i18n('themeGroupIntersection.error.title'),
          i18n('themeGroupIntersection.error.message'));
      });
  }

  isSupported ({ isEditingLayer }) {
    if (!isEditingLayer && this._layer.get(LayerProperty.HAS_FEATURES) && this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length > 0) {
      return hasThemeGroups().catch(error => logger.error(error));
    }
    return Promise.resolve(false);
  }

  requiresObjectSelection () {
    return true;
  }

}
